import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Icon = ({ name, alt, title, className, isLight, children, ...props }) => (
  <i className={classnames('icon d-sm-ib', className)} title={title} {...props}>
    <img src={`/icons/${name}-${isLight ? 'white' : 'black'}.svg`} alt={alt} />
    {children}
  </i>
);

Icon.defaultProps = {
  children: null,
  className: null,
  isLight: false,
  title: null
};

Icon.propTypes = {
  alt: PropTypes.string.isRequired,
  children: PropTypes.any,
  className: PropTypes.string,
  isLight: PropTypes.bool,
  name: PropTypes.string.isRequired,
  title: PropTypes.string
};

export default Icon;
